export default __webpack_public_path__ + "static/media/6_4_0.2c606c07.png";